import { groupService } from '@/helpers/services/group.service';
import i18n from '@/i18n';
// import router from '@/router/index';
import { sharedHelper, filtersHelper } from '@/utils';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const GROUP_MODULE = "group";

// actions
export const GET_ALL_GROUPS = 'getAllGroups';
export const CREATE_GROUP = 'createGroup';
export const GET_GROUP = 'getGroup';
export const UPDATE_GROUP = 'updateGroup';
export const UPDATE_GROUP_STATUS = 'updateGroupStatus';

// mutations
const REQUESTING = "requesting";
const ALL_GROUP_SUCCESS = "allGroupSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_GROUP_SUCCESS = "getGroupSuccess";

export const actions = {
    [GET_ALL_GROUPS]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        groupService.getAllGroups(filter)
                    .then(
                        (result) => {
                            commit(ALL_GROUP_SUCCESS, {data: result});
                            commit(SUCCESS);
                        },
                        (error) => {
                            let message = sharedHelper.getErrorMessage(error);
                            sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                            commit(FAILURE);
                        },
                    );
    },
    [CREATE_GROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return groupService.createGroup(data)
                .then(
                    (result) => {
                        var message = i18n.t('label.createX', [i18n.t('module.group')]);
                        sharedHelper.alertSuccessMessage(message);
                        commit(SUCCESS);
                        dispatch(GET_ALL_GROUPS, {filter});
                        return result;
                    },
                    (error) => {
                        let message = sharedHelper.getErrorMessage(error);
                        sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                        commit(FAILURE);
                    },
                );
    },
    [GET_GROUP]({commit}, {id}) {
        commit(REQUESTING, 'detail');
        return groupService.getGroup(id)
                .then(
                    (result) => {
                        commit(SUCCESS);
                        commit(GET_GROUP_SUCCESS, result);
                        return result;
                    },
                    (error) => {
                        let message = sharedHelper.getErrorMessage(error);
                        sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                        commit(FAILURE);
                    }
                );
    },
    [UPDATE_GROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return groupService.updateGroup(data)
                .then(
                    (result) => {
                        var message = i18n.t('label.updateX', [i18n.t('module.group')]);
                        sharedHelper.alertSuccessMessage(message);
                        commit(SUCCESS);
                        dispatch(GET_ALL_GROUPS, {filter});
                        return result;
                    },
                    (error) => {
                        let message = sharedHelper.getErrorMessage(error);
                        sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                        commit(FAILURE);
                    }
                );
    },
    [UPDATE_GROUP_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return groupService.updateGroupStatus(data)
                    .then(
                        (result) => {
                            var message = i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('module.group')]);
                            sharedHelper.alertSuccessMessage(message);
                            commit(SUCCESS);
                            dispatch(GET_ALL_GROUPS, {filter});
                            return result;
                        },
                        (error) => {
                            let message = sharedHelper.getErrorMessage(error);
                            sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                            commit(FAILURE);
                        }
                    );
    }
}

export const mutations = {
    [ALL_GROUP_SUCCESS](state, {data}) {
        let groups = data.data || [];
        state.list.data = groups;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);
        if(data.success) {
            state.list.data = groups.map(item => {
                return {
                    id : item.uuid,
                    name: item.name,
                    image: item.photo_url,
                    apiCode : item.api_code,
                    colorCode : item.color_code,
                    investorUrl : item.investor_url,
                    websiteUrl : item.website_url,
                    services: item.services,
                    isActive : item.is_active,
                    createdBy : item.created_by,
                    createdAt : filtersHelper.getDateFormat(item.created_at),
                    updatedBy : item.updated_by,
                    updatedAt : filtersHelper.getDateFormat(item.updated_at),
                }
            });
        }
    },
    [GET_GROUP_SUCCESS](state, data) {
        let info = data.data;
        state.details = {
            id : info.uuid,
            name: info.name,
            image: info.photo_url,
            apiCode : info.api_code,
            colorCode : info.color_code,
            investorUrl : info.investor_url,
            websiteUrl : info.website_url,
            services: info.services,
            isActive : info.is_active,
            createdBy : info.created_by,
            createdAt : filtersHelper.getDateFormat(info.created_at),
            updatedBy : info.updated_by,
            updatedAt : filtersHelper.getDateFormat(info.updated_at),
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
}